import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import PhoneInput from '../PhoneInput';
import Input from '../Input';
import validators from '../../helpers/validators';
import { Form as RawForm } from './styles';

const FormActive = function ({
  defaultValues,
  register,
  errors,
  setValue,
  watch,
  triggerValidation,
}) {
  const phone = watch('phone');

  useEffect(() => {
    register({ name: 'phone' }, { validate: validators.phone });
  }, [register]);

  useEffect(() => {
    onChangePhone(defaultValues.phone);
  }, []);

  const onChangePhone = phone => {
    setValue('phone', phone || '');
    if (errors.phone) {
      triggerValidation('phone');
    }
  };

  return (
    <RawForm>
      <Input
        label="Name:"
        name="name"
        defaultValue={defaultValues.name}
        forwardRef={register({ validate: validators.field })}
        placeholder="Type your name"
        alert={errors.name && { type: 'error', message: errors.name.message }}
      />
      <Input
        label="Company Name:"
        name="company"
        defaultValue={defaultValues.company}
        forwardRef={register({ validate: validators.field })}
        placeholder="Type your company name"
        alert={
          errors.company && { type: 'error', message: errors.company.message }
        }
      />
      <Input
        label="Work email:"
        name="email"
        type="email"
        autoComplete="email"
        defaultValue={defaultValues.email}
        forwardRef={register({ validate: validators.email })}
        placeholder="Type your company email"
        alert={
          !errors.email
            ? { type: 'warning', message: 'must be your office 365 email' }
            : { type: 'error', message: errors.email.message }
        }
      />
      <PhoneInput
        label="Phone:"
        value={phone}
        onChange={onChangePhone}
        error={errors.phone && errors.phone.message}
      />
    </RawForm>
  );
};

FormActive.propTypes = {
  defaultValues: PropTypes.shape({
    name: PropTypes.string,
    company: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
  }).isRequired,
  register: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  watch: PropTypes.func.isRequired,
  triggerValidation: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
};

export default FormActive;
